<script setup>
import { getCurrentInstance } from 'vue'
import { useForm } from '@inertiajs/vue3'
import { useLoading } from '@/composables/useLoading'

const { proxy } = getCurrentInstance()
const $t = proxy.$t
const { showLoading, hideLoading } = useLoading()

const props = defineProps({
    user: Object,
})

const form = useForm({
    _method: 'PUT',
    company_name: props.user?.company_name || '',
})

const updateProfileInformation = () => {
    showLoading($t('Updating company information...'));
    const routeName = proxy.route ? proxy.route('client.profile-information.update') : '/profile-information'
    form.post(routeName, {
        errorBag: 'updateProfileInformation',
        preserveScroll: true,
        onFinish: () => hideLoading(),
    })
}
</script>

<template>
    <form @submit.prevent="updateProfileInformation" class="space-y-6">
        <div class="flex w-full gap-5">
            <div class="w-full gap-6">
                <!-- Company Name -->
                <div class="field">
                    <label for="company_name" class="block text-sm font-medium text-surface-700 mb-2">
                        {{ $t('Company name') }}
                    </label>
                    <InputText
                        id="company_name"
                        v-model="form.company_name"
                        class="w-full"
                        :class="{ 'p-invalid': form.errors.company_name }"
                        autocomplete="organization"
                    />
                    <small v-if="form.errors.company_name" class="p-error">
                        {{ form.errors.company_name }}
                    </small>
                </div>
            </div>
    
            <!-- Actions -->
            <div class="flex items-end gap-4">
                <Button
                    type="submit"
                    :label="form.processing ? $t('Saving...') : $t('Save')"
                    icon="pi pi-save"
                    :loading="form.processing"
                    :disabled="form.processing"
                />
    
                <div v-if="form.recentlySuccessful" class="flex items-center gap-2 text-green-600">
                    <i class="pi pi-check-circle"></i>
                    <span class="text-sm font-medium">{{ $t('Saved.') }}</span>
                </div>
            </div>
        </div>
    </form>
</template>

<style scoped>
.field {
    @apply flex flex-col;
}

.p-error {
    @apply text-red-500 text-xs mt-1;
}

.p-invalid {
    @apply border-red-500;
}

.p-button {
    height: 41px;
}
</style>
